// IE 2026 10 06 / ODOO-341407 (заказ Игоря п.2 / п.3): пункт ≡ виджета «Show translation fields» — личная опция вида, флажок формы-меню.
// Дизайн — ie-webscm7-2 docs/i18n_fields_ui_2026-10-06/DESIGN.md §3.1. Чистые функции без Vue (юнит-тест tests/unit/i18nFieldsMenu.test.mjs);
// состояние — store.i18nFields_* (utils/i18nFields.js: по сегменту данных, память стора + localStorage, запись виджета не метится).
// Пункт строит Widget.set_commandPanel, исполняет Widget.i18nFields_toggle (executeVueObjMethod: метод ТОЛЬКО у Widget.vue — у грида / поля
// с тем же именем резолв ушёл бы к ним, DESIGN Р15). Отметка состояния:
//   - форма-меню с параметрами (MenuPanel, fe.ux.menuPanelParams) — чекбокс из param.value;
//   - форма-меню без параметров — active (галочка, полужирный) и иконка;
//   - wj-menu (мобильный профиль) — иконка pi-check-square / pi-stop (у formatMenuItem поля active нет).
// active / cssClass / param.value — геттеры: читают реактивное store.i18nFields_on, открытые меню других виджетов того же сегмента (список и
// формы его записей) показывают общее состояние без пересборки.
import { t } from '@/i18n'
import { TITLE_TOGGLE, TIP_TOGGLE } from '@/utils/i18nFields'

export const TOGGLE_METHOD = 'i18nFields_toggle'
export const ICON_ON = 'pi-check-square'
export const ICON_OFF = 'pi-stop'

// пункт ≡ виджета или null (опция недоступна: механизм выключен fe.i18n.translationFields, язык один, у записи нет сегмента, поиск —
// store.i18nFields_avail; IE 2026 10 06 / ODOO-341407 (U9 D2): свёрнутый виджет пункт получает). Поля пункта — как у фронтового «Translations…»: _key — английский ключ (избранное, поиск), title / tooltip — переводы
export function i18nFieldsMenuItem(store, W) {
    if (!store || !W || typeof store.i18nFields_avail !== 'function' || !store.i18nFields_avail(W)) return null
    const on = () => !!store.i18nFields_on(W)
    const item = { attr_type: 'AttrButton', title: t(TITLE_TOGGLE), _key: TITLE_TOGGLE, tooltip: t(TIP_TOGGLE),
        command: 'executeVueObjMethod', method: TOGGLE_METHOD,
        param: { type: 'check', value: on } }   // форма-меню с параметрами: чекбокс, выбор → pick({ …пункт, value: boolean }), панель открыта
    // сеттеры — no-op: prepare_actionMenu / код меню, пишущий в пункт, не падает на свойстве-геттере (модуль в strict mode)
    Object.defineProperty(item, 'active', { get: on, set: () => {}, enumerable: true, configurable: true })
    Object.defineProperty(item, 'cssClass', { get: () => 'pi p-button-white ' + (on() ? ICON_ON : ICON_OFF), set: () => {}, enumerable: true, configurable: true })
    return item
}

// новое состояние по действию пункта: чекбокс формы-меню несёт value (boolean) — его и ставим; пункт без значения (wj-menu, мобильный
// профиль, форма-меню без параметров, избранное) — переключение
export function i18nFieldsToggleValue(store, W, action) {
    if (action && typeof action.value === 'boolean') return action.value
    return !store.i18nFields_on(W)
}
